// extracted by mini-css-extract-plugin
module.exports = {"container":"Patent_container__N1f79","title":"Patent_title__tKVdK","table":"Patent_table__05m4q"};